import React from 'react';
import { useDropzone, DropzoneOptions } from 'react-dropzone';
import { DropzoneContainer, StyledText, InlineButton } from './styled';
import { UploadIcon } from '@unfold/icon';

interface IDropzoneProps extends DropzoneOptions {
  width?: number | string;
  height?: number | string;
}

const MAX_SIZE_KB = 10485760;
export const Dropzone: React.FC<IDropzoneProps> = (props) => {
  const { getRootProps, getInputProps } = useDropzone({
    multiple: true,
    maxSize: MAX_SIZE_KB,
    ...props,
  });

  const rootProps = getRootProps()

  return (
    <>
      <DropzoneContainer
        {...rootProps}
        width={props.width}
        height={props.height}
      >
        <input {...getInputProps()} />
        <UploadIcon />
      </DropzoneContainer>
      <StyledText variant='Paragraph'>
        or <InlineButton onClick={rootProps?.onClick}><b>browse</b></InlineButton> to select files
      </StyledText>
    </>
  );
};
